<template>
    <vue-scroll>
        <div class="page-header">
            <h1>Notifications</h1>
        </div>
        <el-tabs v-model="activeTab">
            <el-tab-pane
                name="order-status-notifications"
                label="Order Status Notifications"
            >
                <order-status-notifications :form="form" />
            </el-tab-pane>
            <el-tab-pane
                name="site-wide-notifications"
                label="Site-Wide Notifications"
            >
                <custom-notifications />
            </el-tab-pane>
            <!-- <el-tab-pane name="order-reminder-notifications" label="Order Reminder Notifications">
                <order-reminder-notifications />
            </el-tab-pane> -->
        </el-tabs>
    </vue-scroll>
</template>

<script>
import auth from "@/mixins/auth";
import CustomNotifications from "@/views/pages/settings/notifications/CustomNotifications";
import OrderStatusNotifications from "@/views/pages/settings/notifications/OrderStatusNotifications";
import OrderReminderNotifications from "@/views/pages/settings/notifications/OrderReminderNotifications";

function getData() {
    return axios.get(`/web-api/setting/notification`);
}

export default {
    mixins: [auth],
    components: {
        CustomNotifications,
        OrderStatusNotifications,
        OrderReminderNotifications,
    },
    beforeRouteEnter(to, from, next) {
        getData().then((response) => {
            next((vm) => {
                vm.setData(response);
            });
        });
    },
    data: () => ({
        form: new Form({
            order_confirmation: {
                cc: null,
            },
            order_shipped: {
                cc: null,
            },
            digital_display: {
                signup: null,
            },
            forgot_password: {
                cc: null,
            },
        }),
        activeTab: "order-status-notifications",
    }),
    methods: {
        setData(response) {
            _.extend(
                this.form,
                _.pick(response.data, [
                    "order_confirmation",
                    "order_shipped",
                    "digital_display",
                    "forgot_password",
                ])
            );
        },
    },
};
</script>

<style scoped></style>
